<ngx-spinner 
    color="rgba(137,54,129,1)"
    bdColor="rgba(51,51,51,0.8)"
    type="square-jelly-box"
    [fullScreen]="true"
    name="auth-spinner">
    <p style="font-size: 30px; font-weight: bold;">{{loadingText | translate}}</p>
</ngx-spinner>